import AgentDashboard from "@/agent/views/dashboard";
import logins from "@/agent/views/login/index.vue";
import LayoutAgent from "@/agent/components/Layout/index.vue";
import * as guards from "@/router/guard";
import AgentCheckout from "@/agent/views/checkout/index.vue"
import LayoutAgentLogin from "@/agent/components/Layout/login.vue";
import ResultAgent from "@/agent/views/results/index.vue"
import AgentDiscount from "@/agent/views/discount/index.vue"
import AgentPayment from "@/agent/views/results/payment.vue"
import AgentTransaction from "@/agent/views/transactions/index.vue"
import  AgenteRegister from "@/agent/views/Register/index.vue"

export const agents = [
    {
        path: '/agents/login',
        name: 'AgentLogin',
        meta: {layout: LayoutAgentLogin},
        beforeEnter: guards.AuthAgentLogin,
        component: logins,
    },
    {
        path: '/agents/panel/dashboard',
        name: 'AgentDashboard',
        meta: {layout: LayoutAgent},
        beforeEnter: guards.AuthAgent,
        component: AgentDashboard,
    },
    {
        path: '/agents/panel/checkout',
        name: 'AgentCheckout',
        meta: {layout: LayoutAgent},
        beforeEnter: guards.AuthAgent,
        component: AgentCheckout,
    },
    {
        path: '/agents/panel/result/:codeId',
        name: 'AgentResult',
        meta: {layout: LayoutAgent},
        beforeEnter: guards.AuthAgent,
        component: ResultAgent,
    },
    {

        path: '/agents/panel/payment/:params*',
        name: 'AgentPayment',
        meta: {layout: LayoutAgent},
        component: AgentPayment,
    },
    {
        path: '/agents/panel/discount',
        name: 'AgentDiscount',
        meta: {layout: LayoutAgent},
        beforeEnter: guards.AuthAgent,
        component: AgentDiscount,
    },
    {
        path: '/agents/panel/transaction',
        name: 'AgentTransaction',
        meta: {layout: LayoutAgent},
        beforeEnter: guards.AuthAgent,
        component: AgentTransaction,
    },
    {
        path: '/agents/panel/register',
        name: 'AgentReigster',
        meta: {layout: LayoutAgent},
        beforeEnter: guards.AuthAgent,
        component: AgenteRegister,
    },

];